import makeStyles from "@material-ui/core/styles/makeStyles";
import colors from "Styles/colors";

const useStyles = makeStyles(({ spacing, palette }) => ({
  bankAccountTypeRadioGroup: {
    flexDirection: "row",
    marginTop: spacing(),
  },
  radioGroup: {
    flexDirection: "row",
    marginBottom: spacing(),
  },
  radioGroupOption: {
    marginRight: spacing(4),
  },
  enterAccount: {
    border: `1px solid ${colors.black}`,
  },
  enterAccountField: {
    minWidth: spacing(16),
    width: "100%",
  },
  enterAccountFields: {
    display: "flex",
    flexDirection: "column",
    fontSize: 14,
    padding: `${spacing(2)}px ${spacing(2)}px ${spacing(4)}px`,
  },
  enterAccountHeader: {
    backgroundColor: palette.grey[300],
    display: "flex",
    justifyContent: "center",
    padding: `${spacing()}px`,
  },
  enterAccountInput: {
    fontSize: 14,
    padding: "3px 8px 2px !important",
  },
  enterAccountLabel: {
    fontSize: 14,
    whiteSpace: "nowrap",
  },
  error: {
    color: palette.error.main,
    gridColumn: "span 2",
  },
}));

export default useStyles;
